import {
  Lightbulb,
  Sparkles,
  AlertTriangle,
  HelpCircle,
  LayoutDashboard,
  Table,
  Palette,
  Database,
} from 'lucide-react';
import { TEMPLATES, type Template } from './Templates';

const ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  'lightbulb': Lightbulb,
  'sparkles': Sparkles,
  'alert-triangle': AlertTriangle,
  'help-circle': HelpCircle,
  'layout-dashboard': LayoutDashboard,
  'table': Table,
  'palette': Palette,
  'database': Database,
};

interface Props {
  onPick: (t: Template) => void;
}

// TemplateGrid is the empty-state panel shown above the InputBox when no
// messages exist in the current conversation. Clicking a card inserts
// the prompt into the input — the user can edit before sending.
export function TemplateGrid({ onPick }: Props) {
  return (
    <div className="space-y-2 px-3 py-4">
      <div className="mb-1 text-[11px] uppercase tracking-wide text-text-secondary">
        Try a template
      </div>
      <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
        {TEMPLATES.map((t) => {
          const Icon = ICONS[t.icon] ?? Lightbulb;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => onPick(t)}
              className="flex items-start gap-2 rounded-lg border border-border bg-white p-2 text-left text-xs transition hover:border-primary/50 hover:bg-primary/5 dark:border-border-dark dark:bg-surface-dark dark:hover:bg-primary/10"
            >
              <Icon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-primary" />
              <div className="min-w-0">
                <div className="font-medium leading-tight">{t.title}</div>
                <div className="mt-0.5 text-[10px] text-text-secondary leading-snug">
                  {t.description}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
